import { api } from './api';

export interface AuditEntry {
  id: string;
  actor_id: string;
  actor_role: string;
  action: string;
  entity_type: string;
  entity_id: string;
  before_snapshot: unknown;
  after_snapshot: unknown;
  metadata: Record<string, unknown> | null;
  request_id: string | null;
  ip: string | null;
  created_at: string;
}

export interface CorporateAction {
  id: string;
  from_isin: string;
  to_isin: string;
  action_type: 'split' | 'consolidation' | 'bonus' | 'demerger' | 'merger' | 'name_change' | 'fv_change';
  ratio_from: number;
  ratio_to: number;
  effective_date: string;
  announcement_source: string | null;
  notes: string | null;
  retired_at: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export const auditApi = {
  list: (params: {
    entity_type?: string; entity_id?: string; action?: string;
    actor_id?: string; since?: string; until?: string;
    limit?: number; offset?: number;
  }) => api.get<{ rows: AuditEntry[]; limit: number; offset: number }>(
    '/api/admin/audit/log', { params },
  ).then(r => r.data),
};

export const corpActionApi = {
  list: (includeRetired = false) =>
    api.get<{ rows: CorporateAction[] }>(
      `/api/recon/corporate-actions?include_retired=${includeRetired}`,
    ).then(r => r.data),
  create: (body: Omit<CorporateAction, 'id' | 'retired_at' | 'created_by' | 'created_at' | 'updated_at'>) =>
    api.post<{ id: string }>('/api/recon/corporate-actions', body).then(r => r.data),
  update: (id: string, body: Partial<CorporateAction>) =>
    api.put<CorporateAction>(`/api/recon/corporate-actions/${id}`, body).then(r => r.data),
  retire: (id: string, note?: string) =>
    api.post(`/api/recon/corporate-actions/${id}/retire`, { note }).then(r => r.data),
};
